import { render, staticRenderFns } from "./ABMTable.vue?vue&type=template&id=11243053&scoped=true"
import script from "./ABMTable.vue?vue&type=script&lang=js"
export * from "./ABMTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11243053",
  null
  
)

export default component.exports